import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { positionStory } from "store";
import { lnglatAmap, lnglatBmap } from "util/lnglat";
interface GeocoderAddressProps {
  longitude: number;
  latitude: number;
  style?: Object;
}

const GeocoderAddress = (props: GeocoderAddressProps) => {
  const [adrStr, setAdrStr] = useState<string>("");

  async function getAddressFun() {
    let adrStr =
      positionStory.mapType == "amap"
        ? await lnglatAmap(props?.longitude, props?.latitude)
        : await lnglatBmap(props?.longitude, props?.latitude);
    setAdrStr(adrStr as string);
  }

  return (
    <span style={props.style || {}}>
      {adrStr ? (
        <>{adrStr}</>
      ) : (
        <>
          ({props.longitude}、{props.latitude})
          <Button type="link" size="small" onClick={getAddressFun}>
            查看地址
          </Button>
        </>
      )}
    </span>
  );
};

export default GeocoderAddress;
